import { NoteEventTime } from "@spotify/basic-pitch";

export enum TranscriptionMessageType {
  Transcription = 'transcription',
  InitMsg = 'initMsg',
}

interface TranscriptionData {}

export interface TranscriptionMessage {
  type: TranscriptionMessageType;
  data: TranscriptionData;
}

export interface Transcription extends TranscriptionMessage {
  frameID: number,
  midiData: NoteEventTime[];
}

export interface TranscriberState extends TranscriptionMessage {
  isReady: boolean;
}